import Button from '../components/NeumorphicButton';
import Checkbox from '../components/NeumorphicCheckbox';
import TextInput from '../components/NeumorphicTextInput';
import Box from '../components/Box';


export const components = {
     box: {
          type: 'box',
          component: Box
     },
     button: {
          type: 'button',
          component: Button
     },
     checkbox: {
          type: 'checkbox',
          component: Checkbox
     },
     textinput: {
          type: 'textinput',
          component: TextInput
     }
};